import { saveAs } from "file-saver";
import { blobRequestInstance } from "@/api/index";

export async function downloadFile(url: string, file_name: string) {
  const urlParser = new URL(url);
  const params = Array.from(urlParser.searchParams.entries()).reduce(
    (target: any, item) => {
      target[item[0]] = item[1];
      return target;
    },
    {}
  );
  const response = await blobRequestInstance.get(
    `${urlParser.origin}${urlParser.pathname}`,
    { params: params }
  );

  const blob = new Blob([response.data], {
    type: response.data.type
  });

  saveAs(blob, file_name);
}
